// How Zod compiles the schemas in this package (bead hf-vvj9).
//
// ── THE BUG THIS FILE EXISTS TO CLOSE ──────────────────────────────────────────
//
// Zod builds faster object validators with `new Function`, and works out whether it
// may by constructing one inside a `try`. The app is served under
// `script-src 'self'` (apps/web/public/_headers), so that construction is blocked —
// and although Zod catches the throw and quietly falls back, the BROWSER still
// reports the blocked attempt as a `securitypolicyviolation`.
//
// The result was one console error on every single page load, from the only CSP
// violation the app produced. That is worse than it sounds: a console that always
// has an error in it is a console nobody reads, and this product's whole debugging
// story on a helper's phone is "look at what it says". Zod's own source names this
// case and offers `jitless` as the way out.
//
// ── WHY THE BROWSER CHECK, RATHER THAN SETTING IT EVERYWHERE ───────────────────
//
// Convex functions compile these same schemas with no CSP over them, and the JIT
// path is a real speed-up on the server, where validation runs on every call. So the
// flag is set only where it is both free and necessary.
//
// `document` is the proxy for "browser". What we actually mean is "an environment
// that forbids `eval`", and there is no way to ask that question without performing
// the very construction we are avoiding — the check IS the violation. So the honest
// version of this predicate is a runtime check, documented as a proxy rather than
// dressed up as a capability test.
//
// ── WHY IT LIVES BESIDE THE SCHEMAS AND NOT IN THE APP ─────────────────────────
//
// `globalConfig.jitless` is read when a schema is CONSTRUCTED, not when it parses
// (zod/v4/core/schemas.js: `const jit = !globalConfig.jitless`). Every schema in this
// package is built at module scope, so anything that sets the flag after importing
// `@herefor/contracts` is already too late — a mistake worth naming, because it looks
// like it works: the call succeeds, the flag reads back true, and the violation is
// still there on every load.
//
// Every module here that builds a schema imports `./primitives.js`, and `primitives`
// imports this file, so this runs first no matter which door is used. The package
// exposes only its index, so there is no deep import that could get in ahead of it.

import { z } from "zod";

/**
 * Is this a browser, and therefore an environment where the JIT path is unreachable?
 *
 * Takes the global object so the decision is testable without pretending to be
 * somewhere else.
 */
export function isBrowserRuntime(scope: object): boolean {
  return "document" in scope;
}

/** Compile schemas without probing for `eval`. Safe to call more than once. */
export function useJitlessSchemaCompilation(): void {
  z.config({ jitless: true });
}

/** Whether schemas are being compiled without the `eval` probe. */
export function schemaCompilationIsJitless(): boolean {
  return z.config().jitless === true;
}

// THE SIDE EFFECT, and it has to be one: there is no call site early enough for an
// app to make this decision for itself (see the note above).
if (isBrowserRuntime(globalThis)) {
  useJitlessSchemaCompilation();
}
